import React from 'react'
import { useAuth } from '@/lib/AuthContext'
import { useCommunity } from '@/lib/CommunityContext'
import { sdk } from '@/lib/sdk'

/** Fired by "My company" after an invitation is answered, so the menu link reads the state again. */
export const MY_COMPANY_CHANGED = 'memberfy:my-company-changed'

/**
 * Whether "My company" shows in the account menu (F-93 1A): someone on a company's team or with a pending
 * invitation to one (SEC-142). Asked once per community and profile; any failure hides the link rather
 * than guessing.
 */
export const useInMyCompany = () => {
  const { isAuthenticated, isRoleResolved, user } = useAuth()
  const { community } = useCommunity()
  const [inCompany, setInCompany] = React.useState(false)
  const [version, setVersion] = React.useState(0)

  React.useEffect(() => {
    const bump = () => setVersion((v) => v + 1)
    window.addEventListener(MY_COMPANY_CHANGED, bump)
    return () => window.removeEventListener(MY_COMPANY_CHANGED, bump)
  }, [])

  React.useEffect(() => {
    if (!isAuthenticated || !isRoleResolved || !community?.id) { setInCompany(false); return }
    let alive = true
    Promise.all([
      sdk.companies.mine().catch(() => null),
      sdk.companies.myInvitations().catch(() => [])
    ]).then(([mine, invitations]) => { if (alive) setInCompany(Boolean(mine) || invitations.length > 0) })
    return () => { alive = false }
  }, [isAuthenticated, isRoleResolved, community?.id, user?.id, version])

  return inCompany
}
